import React from "react";
import "./type-button.scss";
var TypeButton = function (_a) {
    var text = _a.text;
    return (React.createElement("button", { className: "type-button DMSansNormal_12_400 txt_whispering-periwinkle", style: { cursor: "default" } }, text));
};
export default TypeButton;
